/* eslint-disable import/prefer-default-export */
import { apiV2 } from '../lib/baseAxios';

export const enrichChartMogul = async (
  data: { type: string; key: string; value: any }[]
): Promise<{ clientSecret: string }> => {
  const response = await apiV2.post(`/tracking/chart-mogul/enrich-data`, data);
  return response.data.data;
};
